import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent {

  private _icon: string;

  private readonly url = `/assets/icon/custom-sprite.svg`;

  @Input() width = 16;

  @Input() height = 16;

  @Input() strokeWidth = 0;

  @Input() strokeLinecap = 'round';

  @Input() strokeLinejoin = 'round';

  @Input() stroke = 'black';

  @Input() fill = 'black';

  @Input() set icon(icon: string) {
    this._icon = `${this.url}#${icon}`;
  }

  get icon(): string {
    return this._icon;
  }
}
